import { ProjetoService } from 'src/app/projeto/projeto.service';
import { Component, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-form-projeto-risco',
  	templateUrl: './form-projeto-risco.component.html',
  	styleUrls: ['./form-projeto-risco.component.scss']
})
export class FormProjetoRiscoComponent{
	@ViewChild('Swal') public swal:SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	@Input() projetosRiscos = new Array();
	@Input() stakeholdersSelect = new Array();
	@Input() detalhe: boolean;
	@Input() acao:string;
	create:boolean;
	edit:boolean;
	detail:boolean;
	delete:boolean;
	modalDetalhe:boolean = false;
	form: FormGroup;
	projeto_risco_id:number = null;
	modalTitle:string;
	submitted: boolean = false;
	loading: boolean = false;
	modalReference: NgbModalRef; 
	
	constructor(private projetoService: ProjetoService,  private formBuilder: FormBuilder, private modalService: NgbModal, private activatedRoute: ActivatedRoute){
		
		this.form = this.formBuilder.group({
			projeto_stakeholder_id: this.formBuilder.control('',[Validators.required]),
			projeto_stakeholder: this.formBuilder.control(''),
			nome: this.formBuilder.control('',[Validators.required]),
			exposicao: this.formBuilder.control('',[Validators.required]),
			plano_resposta: this.formBuilder.control('',[Validators.required]),
			observacao: this.formBuilder.control(''),
		})
	}

	ngOnInit(){ 
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(t.permissao.projeto_risco.includes("CONSULTAR"))
			this.detail = true;
		if(t.permissao.projeto_risco.includes("CRIAR"))
			this.create = true;
		if(t.permissao.projeto_risco.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.projeto_risco.includes("EXCLUIR"))
			this.delete = true;
	}
	
	onSubmit(){
		this.submitted = true;
        if(!this.form.valid)
		return;
		this.modalReference.close();
		if(!this.projeto_risco_id){
			this.projetoService.addProjetoRisco(this.activatedRoute.snapshot.params['id'], this.form)
			.subscribe( (success) => {
				this.swal.text = "Risco cadastrado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
			return;
		}

		this.projetoService.editProjetoRisco(this.projeto_risco_id,this.form)
			.subscribe( (success) => {
				this.swal.text = "Risco atualizado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			});
	}
	zeraForm():void{
		this.form.patchValue({
			projeto_stakeholder_id: '',
			projeto_stakeholder: '',
			nome: '',
			exposicao: '',
			plano_resposta: '',
			observacao: '',
		});
	}

	openModal(modal,id:number = null,detalhe:boolean = false) {
		this.projetoService.getProjetoById(this.activatedRoute.snapshot.params['id']).subscribe((success)=>{
			this.stakeholdersSelect = success.dados.stakeholder;

			this.modalDetalhe = detalhe;
			//Se id == null então é cadastro.
			if(!id){
				this.projeto_risco_id = null;
				this.modalTitle = "Cadastrar Risco";
				this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
				return;
			}
			
			//Senão é edição.
			this.projeto_risco_id = id;
			this.modalTitle = "Editar Risco";
			this.projetoService.getProjetoRiscoById(id).subscribe((success) => {
				this.form.patchValue({
					projeto_stakeholder_id: success.dados.projeto_stakeholder_id,
					projeto_stakeholder: success.dados.projeto_stakeholder,
					nome: success.dados.nome,
					exposicao: success.dados.exposicao,
					plano_resposta: success.dados.plano_resposta,
					observacao: success.dados.observacao,
				});
				this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
			})
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
			this.submitted = false;
		});
	}

	askDelete(id:number){
		this.projeto_risco_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.projetoService.delProjetoRisco(this.projeto_risco_id).subscribe( 
		(success) => {
			this.swal.text = "Risco deletado com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
			this.submitted = false;
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
			this.submitted = false;
		});
	}

	onCloseModal(){
		if(this.swal.type == "success"){
			this.projetoService.getProjetoById(this.activatedRoute.snapshot.params['id']).subscribe((success)=>{
				this.projetosRiscos = success.dados.risco;
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
		}
	}
}